import { useEffect } from "react";
import { useRouter } from "next/router";

export default function MesonetClimate() {
    const router = useRouter();

    useEffect(() => {
        router.replace("/mesonet-climate/graphs");
    }, [router]);

    return null;
}
